import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-base",
  "use": "icon-base-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-base\"><defs><style></style></defs><path d=\"M832 1024H192c-70.4 0-128-57.6-128-128V128C64 57.6 121.6 0 192 0h640c70.4 0 128 57.6 128 128v768c0 70.4-57.6 128-128 128zm64-832c0-70.4-57.6-128-128-128H256c-70.4 0-128 57.6-128 128v640c0 70.4 57.6 128 128 128h512c70.4 0 128-57.6 128-128V192zM256 704h512v64H256v-64zm0-192h512v64H256v-64zm0-192h512v64H256v-64z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol